<template>
	<div>
		<j-expendable-box class="bg5 b1 bc7 r2">
			<!-- Header -->
			<div
				slot="header"
				class="pl3 pr3 pt4 pb4 lh125 fs4 c1 fw7"
			>{{ $t("credentials") }}</div>

			<!-- Body -->
			<div class="bt1 bc7" slot="body">
				<j-list :list="computedFields">
					<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
						<!-- Label -->
						<div class="flex xs-6 xs-left xs-middle fw7 c6 lh125">{{ item.label }}</div>

						<!-- Value -->
						<div class="flex xs-4 xs-left xs-middle lh125">{{ item.value }}</div>

						<!-- Actions -->
						<div class="flex xs-2 xs-right xs-middle">
							<crm-icon
								name="edit"
								color="c2"
								class="cu2"
								v-if="item.hasUpdate"
								@click.native="$modal.show('caseCredentialsUpdate')"
							/>
							<crm-icon
								name="delete"
								color="cError"
								class="ml2 cu2"
								v-if="item.hasDelete"
							/>
						</div>
					</div>
				</j-list>
			</div>
		</j-expendable-box>

		<!-- Modal -->
		<core-modal name="caseCredentialsUpdate" :headline="$t('update')">
			<div class="p4">
				<core-form-input
					name="name"
					componentName="j-base-input-text"
					:label="$t('status')"
					v-model="form.status"
				/>
				<j-button @click="updateCase" class="mt6" :isLoading="isLoading">
					{{
					$t("update")
					}}
				</j-button>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JList from "@/components/JList"
import JExpendableBox from "@/components/JExpendableBox"
import CrmIcon from "@/components/CrmIcon"
import CoreModal from "@/modules/core/components/CoreModal"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

import dayjs from "dayjs"

export default {
	components: {
		JList,
		JExpendableBox,
		CrmIcon,
		CoreModal,
		CoreFormInput,
		JButton
	},

	data() {
		return {
			isLoading: false,
			form: {
				status: this.$store.state.caseManagement.case.status || ""
			}
		}
	},

	computed: {
		computedFields() {
			// Get data
			const dateFormat = this.$store.state.settings.dateFormat
			let {
				status,
				createdAt,
				createdBy,
				lastModifiedAt,
				lastModifiedBy
			} = this.$store.state.caseManagement.case

			// Massage data for display
			status = status ? status : "---"
			createdAt = createdAt ? dayjs(createdAt).format(dateFormat) : ""
			lastModifiedAt = lastModifiedAt
				? dayjs(lastModifiedAt).format(dateFormat)
				: ""
			createdBy = createdBy?.username ? createdBy?.username : ""
			lastModifiedBy = lastModifiedBy?.username ? lastModifiedBy?.username : ""

			// Return data
			return [
				{ label: this.$t("status"), value: status, hasUpdate: true },
				{ label: this.$t("created_at"), value: createdAt },
				{ label: this.$t("created_by"), value: createdBy },
				{ label: this.$t("updated_at"), value: lastModifiedAt },
				{ label: this.$t("updated_by"), value: lastModifiedBy }
			]
		}
	},

	methods: {
		async updateCase() {
			const query = gql`
				mutation updateCase($id: String!, $input: updateCaseInput!) {
					updateCase(id: $id, input: $input) {
						errors
						status
						errors_2 {
							code
							message
						}
					}
				}
			`

			const variables = {
				id: this.$store.state.caseManagement.case.id,
				input: {
					status: this.form.status
				}
			}

			this.isLoading = true

			const res = await api({ query, variables })

			this.isLoading = false

			if (res?.data?.updateCase?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateCase?.errors ||
							res?.data?.updateCase?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			} else {
				const stateFilter = function(state) {
					return state.case
				}
				this.$store.commit("caseManagement/UPDATE_CASE", {
					value: this.form.status,
					fieldName: "status",
					actionType: "update",
					stateFilter
				})
				this.$modal.hide("caseCredentialsUpdate")
			}
		}
	}
}
</script>
